import React from "react";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";

import VerticalListDropdown from "../../verticals/components/VerticalListDropdown";
import RecentCandidatesDisplay from "../../verticals/components/RecentCandidatesDisplay";

const FindAndInvite = (props) => {

    return (
        <section className="find_invite_section upward_more_details " >
            <Container>
                <Row noGutters className="d-flex justify-content-center align-items-center">
                    <Col lg="5" xl={{ "size": 4, "offset": 1 }} className="language_wrapper">
                        <div className="pr-3">
                            <h3>Find and invite candidates to apply</h3>
                            <p>The best candidates are not always actively looking. Now you can invite candidates to apply to your jobs in just a few clicks.</p>
                            <p><Link className="text-dark-orange" to="/employers?register=y"><b>Find candidates in your area</b></Link></p>
                        </div>
                    </Col>
                    <Col lg="7">
                        <div className="text-center text-md-right pr-3"><div className="position-relative d-inline-block pr-3"><VerticalListDropdown rightAlign></VerticalListDropdown></div></div>
                        <RecentCandidatesDisplay ></RecentCandidatesDisplay>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}


export default FindAndInvite;